// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__tTyJP","btn":"Button_btn__-qSFb"};